export const RENDER_CONFIG_VERSION = 5;
export const TABLE_GROUPINGS = Object.freeze({
  GROUPED: "grouped",
  UNIFIED: "unified",
});

export const AGENT_SERVICE_TIME_COLUMNS = Object.freeze([
  "agentName",
  "ticketCount",
  "totalServiceTime",
  "serviceTimeShare",
  "average",
  "serviceAverage",
  "avgVsServiceAveragePct",
  "median",
  "p90",
  "activeDays",
  "ticketsPerActiveDay",
  "flags",
  "min",
  "max",
]);

export const AGENT_SERVICE_TIME_COLUMN_DEFINITIONS = Object.freeze([
  { id: "agentName", label: "Agent Name" },
  { id: "ticketCount", label: "Completed Tickets" },
  { id: "totalServiceTime", label: "Total Service Time" },
  { id: "serviceTimeShare", label: "Share of Service Time" },
  { id: "average", label: "Avg / Ticket" },
  { id: "serviceAverage", label: "Service Avg" },
  { id: "avgVsServiceAveragePct", label: "Vs Service Avg" },
  { id: "median", label: "Median" },
  { id: "p90", label: "P90" },
  { id: "activeDays", label: "Active Days" },
  { id: "ticketsPerActiveDay", label: "Tickets / Active Day" },
  { id: "flags", label: "Flags" },
  { id: "min", label: "Min Ticket Time" },
  { id: "max", label: "Max Ticket Time" },
]);

export const AGENT_TICKETS_PER_SERVICE_COLUMNS = Object.freeze([
  "agentName",
  "total",
  "percentage",
  "average",
  "min",
  "max",
  "completed",
  "noShow",
  "unattended",
]);

export const AGENT_TICKETS_PER_SERVICE_COLUMN_DEFINITIONS = Object.freeze([
  { id: "agentName", label: "Agent Name" },
  { id: "total", label: "Total Tickets" },
  { id: "percentage", label: "%" },
  { id: "average", label: "Average" },
  { id: "min", label: "Min" },
  { id: "max", label: "Max" },
  { id: "completed", label: "Completed" },
  { id: "noShow", label: "No Show" },
  { id: "unattended", label: "Unattended" },
]);

export const TICKETS_PER_SERVICE_COLUMNS = Object.freeze([
  "serviceName",
  "total",
  "average",
  "min",
  "max",
  "completed",
  "noShow",
  "unattended",
]);

export const TICKETS_PER_SERVICE_COLUMN_DEFINITIONS = Object.freeze([
  { id: "serviceName", label: "Service" },
  { id: "total", label: "Total Tickets" },
  { id: "average", label: "Average" },
  { id: "min", label: "Min" },
  { id: "max", label: "Max" },
  { id: "completed", label: "Completed" },
  { id: "noShow", label: "No Show" },
  { id: "unattended", label: "Unattended" },
]);

export const SERVICE_TIME_PER_SERVICE_COLUMNS = Object.freeze([
  "serviceName",
  "completed",
  "totalServiceTime",
  "average",
  "min",
  "max",
]);

export const SERVICE_TIME_PER_SERVICE_COLUMN_DEFINITIONS = Object.freeze([
  { id: "serviceName", label: "Service" },
  { id: "completed", label: "Completed Tickets" },
  { id: "totalServiceTime", label: "Total Service Time" },
  { id: "average", label: "Average" },
  { id: "min", label: "Min" },
  { id: "max", label: "Max" },
]);

export const WAITING_TIME_PER_SERVICE_COLUMNS = Object.freeze([
  "serviceName",
  "completed",
  "totalWaitingTime",
  "average",
  "min",
  "max",
]);

export const WAITING_TIME_PER_SERVICE_COLUMN_DEFINITIONS = Object.freeze([
  { id: "serviceName", label: "Service" },
  { id: "completed", label: "Completed Tickets" },
  { id: "totalWaitingTime", label: "Total Waiting Time" },
  { id: "average", label: "Average" },
  { id: "min", label: "Min" },
  { id: "max", label: "Max" },
]);

export const ARRIVAL_RATES_PER_SERVICE_COLUMNS = Object.freeze([
  "serviceName",
  "total",
  "percentage",
  "average",
  "min",
  "max",
]);

export const ARRIVAL_RATES_PER_SERVICE_COLUMN_DEFINITIONS = Object.freeze([
  { id: "serviceName", label: "Service" },
  { id: "total", label: "Total Visitors" },
  { id: "percentage", label: "%" },
  { id: "average", label: "Average" },
  { id: "min", label: "Min" },
  { id: "max", label: "Max" },
]);

export const ARRIVAL_RATES_SUMMARY_COLUMNS = Object.freeze([
  "scopeName",
  "total",
  "average",
  "min",
  "max",
]);

export const ARRIVAL_RATES_SUMMARY_COLUMN_DEFINITIONS = Object.freeze([
  { id: "scopeName", label: "Scope" },
  { id: "total", label: "Total Visitors" },
  { id: "average", label: "Average" },
  { id: "min", label: "Min" },
  { id: "max", label: "Max" },
]);

export const TICKET_SUMMARY_COLUMNS = Object.freeze([
  "scopeName",
  "total",
  "average",
  "min",
  "max",
  "completed",
  "noShow",
  "unattended",
]);

export const TICKET_SUMMARY_COLUMN_DEFINITIONS = Object.freeze([
  { id: "scopeName", label: "Scope" },
  { id: "total", label: "Total Tickets" },
  { id: "average", label: "Average" },
  { id: "min", label: "Min" },
  { id: "max", label: "Max" },
  { id: "completed", label: "Completed" },
  { id: "noShow", label: "No Show" },
  { id: "unattended", label: "Unattended" },
]);

export const WAITING_TIME_SUMMARY_COLUMNS = Object.freeze([
  "scopeName",
  "total",
  "totalWaitingTime",
  "average",
  "averagePerDay",
  "min",
  "max",
]);

export const WAITING_TIME_SUMMARY_COLUMN_DEFINITIONS = Object.freeze([
  { id: "scopeName", label: "Scope" },
  { id: "total", label: "Total Tickets" },
  { id: "totalWaitingTime", label: "Total Waiting Time" },
  { id: "average", label: "Avg / Ticket" },
  { id: "averagePerDay", label: "Avg / Day" },
  { id: "min", label: "Min" },
  { id: "max", label: "Max" },
]);

export const CUSTOMERS_IN_BRANCH_COLUMNS = Object.freeze([
  "scopeName",
  "total",
  "min",
  "max",
  "average",
  "abandonmentRate",
  "peakHour",
]);

export const CUSTOMERS_IN_BRANCH_COLUMN_DEFINITIONS = Object.freeze([
  { id: "scopeName", label: "Branch" },
  { id: "total", label: "Avg Total / Day" },
  { id: "min", label: "Avg Min / Hour" },
  { id: "max", label: "Avg Max / Hour" },
  { id: "average", label: "Avg / Hour" },
  { id: "abandonmentRate", label: "Abandonment %" },
  { id: "peakHour", label: "Peak Hour" },
]);

export const DEFAULT_RENDER_CONFIG = Object.freeze({
  version: RENDER_CONFIG_VERSION,
  charts: Object.freeze({ enabled: true }),
  density: "comfortable",
  columns: AGENT_SERVICE_TIME_COLUMNS,
  sort: null,
  tables: Object.freeze({ grouping: TABLE_GROUPINGS.GROUPED }),
});

const DENSITIES = new Set(["comfortable", "compact"]);
const GROUPINGS = new Set(Object.values(TABLE_GROUPINGS));
const DIRECTION_LABELS = Object.freeze({ asc: "ascending", desc: "descending" });
const DIRECTION_SHORT_LABELS = Object.freeze({ asc: "asc", desc: "desc" });

const getColumnIds = (columnDefinitions = AGENT_SERVICE_TIME_COLUMN_DEFINITIONS) =>
  columnDefinitions.map((column) => column.id);

const getColumnLabels = (columnDefinitions = AGENT_SERVICE_TIME_COLUMN_DEFINITIONS) =>
  Object.fromEntries(columnDefinitions.map((column) => [column.id, column.label]));

export const normalizeRenderConfig = (input = null, options = {}) => {
  const columnDefinitions = options.columnDefinitions || AGENT_SERVICE_TIME_COLUMN_DEFINITIONS;
  const defaultColumns = options.defaultColumns ||
    (options.columnDefinitions ? getColumnIds(columnDefinitions) : DEFAULT_RENDER_CONFIG.columns);
  const sortableColumns = new Set(getColumnIds(columnDefinitions));
  const source = input && typeof input === "object" ? input : {};
  const charts = source.charts && typeof source.charts === "object" ? source.charts : {};
  const tables = source.tables && typeof source.tables === "object" ? source.tables : {};
  const columns = Array.isArray(source.columns)
    ? source.columns.filter(
        (column, index, values) =>
          defaultColumns.includes(column) && values.indexOf(column) === index
      )
    : defaultColumns;

  const sort =
    source.sort &&
    sortableColumns.has(source.sort.column) &&
    ["asc", "desc"].includes(source.sort.direction)
      ? { column: source.sort.column, direction: source.sort.direction }
      : null;

  const chartsEnabled =
    typeof charts.enabled === "boolean"
      ? charts.enabled
      : DEFAULT_RENDER_CONFIG.charts.enabled;

  return {
    version: RENDER_CONFIG_VERSION,
    charts: { enabled: chartsEnabled },
    density: DENSITIES.has(source.density) ? source.density : DEFAULT_RENDER_CONFIG.density,
    columns: columns.length ? columns : defaultColumns,
    sort,
    tables: {
      grouping: GROUPINGS.has(tables.grouping)
        ? tables.grouping
        : DEFAULT_RENDER_CONFIG.tables.grouping,
    },
  };
};

const getSortValue = (row, column) => {
  if (column === "totalServiceTime") return row.sum || row.sessionInSeconds || 0;
  if (column === "totalWaitingTime") return row.waitingTimeInSeconds || row.totalWaitingTime || 0;
  if (column === "percentage" || column === "serviceTimeShare") {
    return row.serviceTimeShare ?? row.totalPct ?? 0;
  }
  if (column === "serviceAverage") return row.serviceAverage ?? row.serviceAverageServiceTime ?? 0;
  if (column === "avgVsServiceAveragePct") return row.avgVsServiceAveragePct ?? 0;
  if (column === "median") return row.medianServiceTime ?? row.median ?? 0;
  if (column === "p90") return row.p90ServiceTime ?? row.p90 ?? 0;
  if (column === "activeDays") return row.activeDays ?? 0;
  if (column === "ticketsPerActiveDay") return row.ticketsPerActiveDay ?? 0;
  if (column === "flags") return Array.isArray(row.flags) ? row.flags.join(", ") : row.flags || "";
  if (column === "ticketCount") return resolveAgentServiceTicketCount(row);
  if (column === "agentName") return row.agentName || "";
  if (column === "serviceName") return row.serviceName || row.name || "";
  if (column === "scopeName") return row.scopeName || row.branchName || "";
  if (column === "completed") return row.numCompleted || row.completed || 0;
  if (column === "noShow") return row.numNoShow || row.noShow || 0;
  if (column === "unattended") return row.numUnattended || row.unattended || 0;
  if (column === "averagePerDay") return row.avgWaitingTimePerDay || 0;
  if (column === "abandonmentRate") return row.abondonmentRate || row.abandonmentRate || 0;
  if (column === "peakHour") return row.peakHour || "";
  return row[column] || 0;
};

export const sortReportRows = (rows, renderConfig, options = {}) => {
  const config = normalizeRenderConfig(renderConfig, options);
  if (!config.sort) return [...rows];

  const direction = config.sort.direction === "asc" ? 1 : -1;
  return [...rows].sort((a, b) => {
    const left = getSortValue(a, config.sort.column);
    const right = getSortValue(b, config.sort.column);
    if (typeof left === "string" || typeof right === "string") {
      return String(left).localeCompare(String(right)) * direction;
    }
    return (left - right) * direction;
  });
};

export const updateRenderConfig = (renderConfig, patch, options = {}) =>
  normalizeRenderConfig({
    ...normalizeRenderConfig(renderConfig, options),
    ...patch,
    charts: {
      ...normalizeRenderConfig(renderConfig, options).charts,
      ...(patch.charts || {}),
    },
    tables: {
      ...normalizeRenderConfig(renderConfig, options).tables,
      ...(patch.tables || {}),
    },
  }, options);

export const usesUnifiedTable = (renderConfig, options = {}) => {
  const config = normalizeRenderConfig(renderConfig, options);
  return !config.charts.enabled && config.tables.grouping === TABLE_GROUPINGS.UNIFIED;
};

export const getRenderConfigSummaryItems = (renderConfig, options = {}) => {
  const config = normalizeRenderConfig(renderConfig, options);
  const columnLabels = getColumnLabels(options.columnDefinitions);
  const items = [];

  if (!config.charts.enabled) {
    items.push("Charts off");
  }

  if (config.density === "compact") {
    items.push("Compact table");
  }

  if (config.sort) {
    items.push(
      `Sorted: ${columnLabels[config.sort.column] || config.sort.column} ${
        DIRECTION_LABELS[config.sort.direction]
      }`
    );
  }

  if (usesUnifiedTable(config)) {
    items.push("Unified table");
  }

  return items;
};

export const getRenderConfigSummary = (renderConfig) => {
  const items = getRenderConfigSummaryItems(renderConfig);
  return items.length ? `Presentation: ${items.join(" | ")}` : "";
};

export const getMergeRenderConfigSummaryItems = (renderConfig, options = {}) => {
  const config = normalizeRenderConfig(renderConfig, options);
  const columnLabels = getColumnLabels(options.columnDefinitions);
  const items = [];

  if (!config.charts.enabled) {
    items.push("Charts off");
  }

  if (config.density === "compact") {
    items.push("Compact table");
  }

  if (config.sort) {
    items.push(
      `Sort: ${columnLabels[config.sort.column] || config.sort.column} ${
        DIRECTION_LABELS[config.sort.direction]
      }`
    );
  }

  if (usesUnifiedTable(config)) {
    items.push("Unified table");
  }

  return items;
};

export const getMergeRenderConfigStateItems = (renderConfig, options = {}) => {
  const config = normalizeRenderConfig(renderConfig, options);
  const columnLabels = getColumnLabels(options.columnDefinitions);
  const items = [config.charts.enabled ? "Charts on" : "Charts off"];

  items.push(`Density: ${config.density === "compact" ? "Compact" : "Comfortable"}`);
  items.push(
    config.sort
      ? `Sort: ${columnLabels[config.sort.column] || config.sort.column} ${
          DIRECTION_SHORT_LABELS[config.sort.direction]
        }`
      : "No sort"
  );

  if (usesUnifiedTable(config)) {
    items.push("Unified table");
  }

  return items;
};
import { resolveAgentServiceTicketCount } from "./agentServiceTimeMetrics";
